import { render, staticRenderFns } from "./EpcArrayBru.vue?vue&type=template&id=1fa335ae&scoped=true&"
import script from "./EpcArrayBru.vue?vue&type=script&lang=js&"
export * from "./EpcArrayBru.vue?vue&type=script&lang=js&"
import style0 from "./EpcArrayBru.vue?vue&type=style&index=0&id=1fa335ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa335ae",
  null
  
)

export default component.exports